import React from 'react'

import Dataset from '../../../components/Dataset'

import meta from './_meta.yaml'

export default () => (
  <Dataset
    meta={meta}
  />
)
